import { render } from "./AddEvaluationForm.vue?vue&type=template&id=6cd1dd4c"
import script from "./AddEvaluationForm.vue?vue&type=script&lang=js"
export * from "./AddEvaluationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__